/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  HTTPValidationError,
  ReviewItem,
} from '../models/index';
import {
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    ReviewItemFromJSON,
    ReviewItemToJSON,
} from '../models/index';

export interface ListReviewQueueRequest {
    eventId?: string | null;
    workshopId?: string | null;
}

/**
 * 
 */
export class ReviewApi extends runtime.BaseAPI {

    /**
     * Results needing attention in one event or workshop: near-misses and tolerance acceptances not yet reviewed, and flagged results; organizers for events, the mentor or an organization admin for workshops.
     * List Review Queue
     */
    async listReviewQueueRaw(requestParameters: ListReviewQueueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ReviewItem>>> {
        const queryParameters: any = {};

        if (requestParameters['eventId'] != null) {
            queryParameters['event_id'] = requestParameters['eventId'];
        }

        if (requestParameters['workshopId'] != null) {
            queryParameters['workshop_id'] = requestParameters['workshopId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/review/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ReviewItemFromJSON));
    }

    /**
     * Results needing attention in one event or workshop: near-misses and tolerance acceptances not yet reviewed, and flagged results; organizers for events, the mentor or an organization admin for workshops.
     * List Review Queue
     */
    async listReviewQueue(requestParameters: ListReviewQueueRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ReviewItem>> {
        const response = await this.listReviewQueueRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
